import { environment } from 'src/environment';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { BaseService, StorageService, SettingsService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { VoucherService } from 'src/app/core/services/voucher.service';
import { BULSATCODE, COUPON, VOUCHER, K_GOOGLE_CAPTCHA, VODAFONE_ROMANIA } from 'src/app/shared/constants/key.constants';
import { VOUCHER_SIGNIN } from 'src/app/shared/constants/local.constants';
import * as uikit from 'uikit'
import { ActivatedRoute, Router } from '@angular/router';
import { OperatorService } from '../../../../../core/services/operator.service';
import { R_ACCOUNT_SETTINGS } from 'src/app/shared/constants';
import { ApplicationService } from 'src/app/core/services/application.service';

declare const grecaptcha: any;
@Component({
  selector: 'app-redeem-voucher-screen',
  templateUrl: './redeem-voucher-screen.component.html',
  styleUrls: ['./redeem-voucher-screen.component.scss', '../modal-screens.scss']
})
export class RedeemVoucherScreenComponent implements OnInit {
  voucher_code: string;
  voucherSuccessPage: boolean = false;
  message: any;
  successDesc: any;
  errorMsg: string;
  disabledBtn: boolean = false;
  @Output() newItemEvent? = new EventEmitter<string>();
  voucherContent: boolean;
  voucherSuccess: any;
  voucherReq = false;
  voucherData:any;
  coupon_apply:boolean = false;
  card_payment:boolean = false;
  checkout_session_id;
  @Output() updateTitleEvent? = new EventEmitter<string>();
  @Input() myAccountData;
  step = 1
  payment_type:any;
  paymentMethodLength:any;
  coupon_valid;
  operator: any;
  currentOperator: any;
  googleReCaptchaKey = K_GOOGLE_CAPTCHA;
  @Input() page = '';

  accountPageUrl = R_ACCOUNT_SETTINGS;
  paymentMethods;
  successMessage = {
    mainText: '',
    subText: ''
  };
  paymentDialog = true;
  VoucherNotAppliedMsg: string;
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private uikitService: UikitService,
    private subscriptionService: SubscriptionService, private storageService: StorageService, 
    private loggerService: LoggerService, public baseService: BaseService, private voucherService: VoucherService,
     private paymentService: PaymentService, private router: Router,
      private settingsService: SettingsService, private appService: ApplicationService) {
    this.googleReCaptchaKey = this.settingsService.googleRecaptcaKey;
    this.baseService.disableFormButton = false;
    uikit.util.on(document, 'beforehide', '#redeem-voucher-screen', ()=> this.resetData());
  }

 ngOnInit(): void {
    this.paymentMethods = this.myAccountData?.stripe_payment_method;
    this.paymentService.backNavigation.subscribe(data => {
       if(data === true) {
        const settingsPage = this.router.url.match('/settings');
        if (settingsPage?.length && this.paymentMethodLength == 1 && this.step == 4) this.step = 3;
        else this.step = this.step - 1
       }
    })
  }

  resetData() {
    this.voucher_code = '';
    this.errorMsg = undefined
    this.disabledBtn = false;
    this.voucherSuccessPage = false;
    this.voucherContent = false;
    this.coupon_apply = false;
  }
  resetErrorMsg() {
    this.errorMsg = undefined;
    this.disabledBtn = false;
    this.voucherContent = false;
  }
  // activate Voucher details
  async voucher_apply() {
    this.disabledBtn = true;
    this.errorMsg = undefined
    if (this.voucher_code != '' || this.voucher_code != undefined) {
      const uId = this.storageService.getLocalStore('u_id');
      if (uId && this.voucherData.discount_type === COUPON) {
        this.storageService.setLocalStore('discount_type', this.voucherData.discount_type);
        this.storageService.setLocalStore('discount_code', this.voucher_code);
        this.storageService.setLocalStore(VOUCHER_SIGNIN, '1');
        // if stripe payment methods(like card,ideal)length is greater than 1, then we'll show step2 which shows payment methods popup else we'll redirect to step3 which shows existed single payment type
        if (this.appService.userPaymentMethods?.length) this.step = 2;
        else this.step = 3;
        this.successMessage.mainText = this.configService.localeKeys?.["plans.coupon_applied.text"] || 'Coupon is Applied';
        this.successMessage.subText =  this.configService.localeKeys?.["plans.coupon_assigned_to_your_account.text"] || 'Your coupon has been assigned to your account';
      } else if(uId && this.voucherData.discount_type === VOUCHER) {
        if (this.voucher_code.trim() === '' || this.voucher_code === undefined) {
          let voucherReq = this.configService.localeKeys?.["voucher.code_required.text"];
          // this.uikitService.staticErrorMessage(voucherReq);
          this.errorMsg = voucherReq;
          this.disabledBtn = false;
          this.successMessage.mainText = this.configService.localeKeys?.["voucher.voucher_activated.text"];
          this.successMessage.subText = this.configService.localeKeys?.["account.voucher_assigned.text"];
          return;
        }
        const Coupendata = { voucher_code: this.voucher_code };
        const couponResp: any = await this.subscriptionService.applyCoupon(Coupendata);
        this.disabledBtn = false;
        if (couponResp.status_code === 200) {
          this.voucherSuccessPage = true;
          this.message = couponResp.message;
          this.successDesc = couponResp.data.desc;
          this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
          this.storageService.setLocalStore('user_type', 'Operator User');
          this.storageService.setLocalStore('operator_name', couponResp.data.partner_name + '-' + couponResp.data.partner_description);
          this.loggerService.updatedMemoryStorage(undefined);
          this.newItemEvent.emit('redeem');
        } else {
          // this.uikitService.staticErrorMessage(couponResp?.error?.error?.message);
          this.disabledBtn = true;
          this.errorMsg = couponResp?.error?.error?.message
        }
      }
      else if(uId && (this.voucherData.discount_type === BULSATCODE || this.voucherData.discount_type === VODAFONE_ROMANIA)) {
        if (this.voucher_code === '' || this.voucher_code === undefined) {
          let voucherReq = this.configService.localeKeys?.["operator.contract_id_required.text"];
          this.errorMsg = voucherReq;
          this.disabledBtn = false;
          return;
        }
        const Coupendata = { code: this.voucher_code, operator_reference_number:this.storageService.getLocalStore('operatorReference'),customer_identifier_type:this.storageService.getLocalStore('customerIdentifierType')};
        const couponResp: any = await this.voucherService.bulsatSubcription(Coupendata);
        this.disabledBtn = false;
        if (couponResp.status_code === 200) {
          this.voucherSuccessPage = true;
          this.message = couponResp.message;
          this.successDesc = couponResp.data.desc;
          this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
          this.storageService.setLocalStore('user_type', 'Operator User');
          this.storageService.setLocalStore('operator_name', couponResp.data.partner_name + '-' + couponResp.data.partner_description);
          this.loggerService.updatedMemoryStorage(undefined);
          this.newItemEvent.emit('redeem');
        } else {
          this.disabledBtn = true;
          this.errorMsg = couponResp?.error?.error?.message
        }
      }
    }
  }

  validateVoucherHelper(){
    if (this.voucher_code.trim() === '' || this.voucher_code === undefined) {
      this.voucherReq = true;
    } else {
        let voucherData = {code:this.voucher_code};
        if(this.settingsService.googleRecaptchaEnabled == '1'){
          if(grecaptcha){
            grecaptcha.enterprise.ready(() => {
              grecaptcha.enterprise.execute(this.googleReCaptchaKey, {action: 'Voucher'}).then((token) => {
                Object.assign(voucherData, {"recaptchaToken" : token});
                this.validateVoucher(voucherData);
              });
            });
          }
        } else {
          this.validateVoucher(voucherData);
        }
    }
  }

  validateVoucher(voucherData) {
    this.voucherService.validateVoucher(voucherData).subscribe((resp) => {
      if (resp.status_code === 200) {
        this.voucherReq = false;
        this.voucherSuccess = resp.data.discount_text;
        this.voucherData = resp.data;
        this.voucherContent = true;
        // this.voucherHelp = false;
        // this.showErr = false;
        this.errorMsg = '';
        this.baseService.voucherCaptchaValidation.next(0);
        this.storageService.removeLocalStore('voucherErrorCounter');
        this.baseService.voucherValidation.next(true);
      } else {
        this.baseService.voucherCounterErrorFn();
      }
    }, (error) => {
      this.errorMsg = error?.error?.error?.message;
      this.voucherReq = false;
      // this.showErr = true;
      this.baseService.voucherCounterErrorFn();
    }, () => {
      this.baseService.loaderSource.next(false);
    });
  }

  updateMsg(){
    this.voucherReq = false;
  }

  selectedPlan(evt) {
    this.checkout_session_id = evt.session_id;
    this.subscriptionService.paymentSessionId = evt.session_id;
    this.coupon_valid = evt.coupon_valid;
    const paymentMethods = this.appService.userPaymentMethods;
    if (evt?.freePlan === 1) {
      this.step = 5;
    } else if (paymentMethods?.length === 1) {
      // when only one payment method is present we are checking for it, skipping the payment methods page(where all the payment methods are present) and navigating to that payment page(ex: card, ideal) 
      this.step = 4;
      this.paymentMethodLength = paymentMethods.length;
      this.paymentService.paymentMethodLength = paymentMethods.length;
      this.payment_type = paymentMethods[0];
    } else this.step = 3;
  }

  cardMethod(evt) {
    this.step = 4;
    this.paymentMethodLength = evt.paymentMethodLength;
    this.paymentService.paymentMethodLength = evt.paymentMethodLength;
    this.payment_type = evt.payment_type;
  }

  idealPayment(data) {
    this.baseService.loaderSource.next(false);
    this.voucherSuccessPage = true;
    if (!this.coupon_valid) {
      const paymentDetail = data.url_data;
      this.VoucherNotAppliedMsg = paymentDetail.next_due_date ?
      ((this.configService.localeKeys?.["plans.next_payment_wii_be_charged.text"] || 'Your new plan will be valid starting from')
      + ' ' + paymentDetail.next_due_date +
      (this.configService.localeKeys?.["plans.next_payment_will_be_charged_part2.text"] || '.')) : '';
    }
    this.step = 5;
  }

  cardPayment(data) {
    this.baseService.loaderSource.next(false);
    this.voucherSuccessPage = true;
    if (!this.coupon_valid) {
      const paymentDetail = data.url_data;
      this.VoucherNotAppliedMsg = paymentDetail.next_due_date ?
      ((this.configService.localeKeys?.["plans.next_payment_wii_be_charged.text"] || 'Your new plan will be valid starting from')
      + ' ' + paymentDetail.next_due_date +
      (this.configService.localeKeys?.["plans.next_payment_will_be_charged_part2.text"] || '.')) : '';
    }
    this.step = 5;
  }

  getSignStep($event) {
    this.step = $event;
  }
}
